import {ReactComponent as CircleNextIcon} from 'icons/circle-next.svg'
import {ReactComponent as CirclePrevIcon} from 'icons/circle-prev.svg'
import {useCallback, useState} from 'react'
import {Ventrata} from 'types'

type Props = {
  galleryImages: Ventrata.Image[]
}

export const Carousel = ({galleryImages}: Props) => {
  const [index, setIndex] = useState(0)

  const next = useCallback(() => {
    setIndex((index) => (index + 1) % galleryImages.length)
  }, [galleryImages.length])

  const prev = useCallback(() => {
    setIndex((index) => (index - 1) % galleryImages.length)
  }, [galleryImages.length])

  const currentImage = galleryImages[index]

  if (galleryImages.length === 0) {
    return null
  }

  return (
    <div className="relative py-10">
      <div
        className="w-full h-[264px] d:h-[384px] rounded-2xl"
        style={{
          backgroundImage: `url(${currentImage.url})` || '',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <CircleNextIcon
        onClick={next}
        className="absolute top-[calc(50%-16px)] right-2 hover:opacity-80 cursor-pointer"
      />
      <CirclePrevIcon onClick={prev} className="absolute top-[calc(50%-16px)] left-2 hover:opacity-80 cursor-pointer" />
    </div>
  )
}
